import img1 from "../../assets/Images/Reports/Service Report.png"

export default function ServiceReport() {
    return (
        <section id="service-report" className="space-y-16">
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    2. Service Report
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    The Service Report provides a summarized view of all services offered
                    during events, showing how often each service was used and the total
                    revenue generated.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        This report is designed for management and accounts teams to analyze
                        service-level performance. It helps identify high-demand services,
                        revenue contribution per service, and overall service utilization
                        trends across events.
                    </p>
                </section>
            </section>


            {/* FILTERS */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Filters & View Controls
                    </h3>
                    <p className="text-slate-600 mb-3">
                        The Service Report includes multiple filters that control how the
                        summary data is generated and displayed.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Date range filter (From / To)</li>
                        <li>Service selection (All services or a specific service)</li>
                        <li>View Mode for grouping data</li>
                        <li>Filters apply directly to the summary output</li>
                    </ul>
                </div>
            </section>

            {/* VIEW MODE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    View Mode: Group by Service
                </h3>

                <p className="text-slate-600 mb-3">
                    The View Mode option determines how the report data is grouped. In the
                    default “Group by Service” mode, each row represents a single service
                    aggregated across all bookings.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Services are grouped by service title</li>
                    <li>Quantities and revenue are summed automatically</li>
                    <li>Helps compare service performance at a glance</li>
                </ul>
            </section>

            {/* TABLE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">
                    Services Summary Table
                </h3>

                <p className="text-slate-600 mb-4">
                    The Services Summary table displays aggregated service-level data for
                    the selected filters.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Service Title</li>
                    <li>Pricing Type (Flat / Per Head)</li>
                    <li>Unit Price</li>
                    <li>Total Bookings using the service</li>
                    <li>Total Quantity consumed</li>
                    <li>Total Revenue generated</li>
                </ul>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* SEARCH */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Search Within Services
                </h3>

                <p className="text-slate-600 mb-3">
                    The search box allows quick filtering of services within the summary
                    table.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Search by service name</li>
                    <li>Quickly locate high-value services</li>
                    <li>Useful when managing a large service catalog</li>
                </ul>
            </section>

            {/* BUSINESS VALUE */}
            <section className="bg-[#C9A24E]/10 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Business Insights from Service Report
                </h3>

                <p className="text-slate-600 mb-3">
                    The Service Report helps management make informed decisions related to
                    pricing, promotions, and service offerings.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Identify top-performing services</li>
                    <li>Detect underutilized or zero-usage services</li>
                    <li>Evaluate pricing effectiveness</li>
                    <li>Plan service bundles and upsells</li>
                </ul>
            </section>

        </section>
    );
}
